var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Event Name","hide-footer":""},on:{"hide":function($event){return _vm.$emit('update:is-show', false)}},model:{value:(_vm.showInfoModal),callback:function ($$v) {_vm.showInfoModal=$$v},expression:"showInfoModal"}},[_c('div',[_vm._v(" Event name as it appears in Affise payout screen ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }